(function(){
var T={"CS2":"CS:GO / CS2","ATL":"Call of Duty (Atlanta FaZe)","R6":"Rainbow Six","FN":"Fortnite","PUBG":"PUBG","COD":"Call of Duty","HALO":"Halo","RL":"Rocket League","FO":"FIFA Online","PM":"PUBG Mobile","WZ":"Call of Duty: Warzone","APEX":"Apex Legends","BLK":"Call of Duty (FaZe Black)","VAL":"VALORANT","OW":"Overwatch","FIFA":"FIFA","SSBU":"Super Smash Bros. Ultimate","RENN":"Rennsport","VGC":"VALORANT (FaZe Clan GC)","RED":"Call of Duty (FaZe Red)","FRA":"Call of Duty (FaZe France)","FG":"Fighting Games"};
var P=[
["Simp","Chris Lehr","USA",5104000,1,"ATL"],
["aBeZy","Tyler Pharris","USA",3490000,0,"ATL"],
["Cellium","McArthur Jovel","USA",3490000,0,"ATL"],
["rain","Håvard Nygaard","Norway",3279169,0,"CS2"],
["karrigan","Finn Andersen","Denmark",1961507,1,"CS2"],
["broky","Helvijs Saukants","Latvia",1822066,1,"CS2"],
["Arcitys","Alec Sanderson","USA",1632500,0,"ATL"],
["ropz","Robin Kool","Estonia",1312317,0,"CS2"],
["Priestahh","Preston Greiner","USA",1139000,0,"ATL"],
["MajorManiak","Michael Szymaniak","USA",1139000,0,"ATL"],
["Twistzz","Russel Van Dulken","Canada",1140817,0,"CS2"],
["NiKo","Nikola Kovač","Bosnia",988735,0,"CS2"],
["olofmeister","Olof Kajbjer","Sweden",861441,0,"CS2"],
["karrigan","Finn Andersen","Denmark",855426,0,"CS2"],
["GuardiaN","Ladislav Kovács","Slovakia",710891,0,"CS2"],
["frozen","David Čerňanský","Slovakia",705300,1,"CS2"],
["Cyber","Jaime Ramos","Brazil",580282,0,"R6"],
["soulz1","Lucas Romero Schinke","Brazil",580282,1,"R6"],
["Drazah","Zachary Jordan","USA",349000,0,"ATL"],
["SlasheR","Austin Liddicoat","USA",390000,0,"ATL"],
["EliGE","Jonathan Jablonowski","USA",463000,0,"CS2"],
["Tfue","Turner Tenney","USA",441130,0,"FN"],
["VITAKING","Victor Augusto dos Santos","Brazil",437193,1,"R6"],
["Dubs","Daniel Walsh","USA",432738,0,"FN"],
["fuzzface","David Tillberg","Sweden",428069,0,"PUBG"],
["Handyy","Thiago Sá Ferreira","Brazil",428172,1,"R6"],
["KDS","Eduardo Chiste Fontes Santos","Brazil",428172,1,"R6"],
["Aitzy","Ludvik Greger Jahnsen","Norway",386733,0,"PUBG"],
["Cloakzy","Dennis Lepore","USA",357423,0,"FN"],
["ubah","Ivan Kapustin","Russia",335069,0,"PUBG"],
["mxey","Anssi Pekkonen","Finland",319850,0,"PUBG"],
["Megga","Noam Ackenine","USA",302033,0,"FN"],
["ZooMaa","Tom Paparratto","USA",301154,0,"COD"],
["Firstkiller","Jason Corral","USA",295397,0,"RL"],
["coldzera","Marcelo David","Brazil",274929,0,"CS2"],
["kioShiMa","Fabien Fiey","France",260756,0,"CS2"],
["Sypical","Caden Pellegrin","USA",200701,0,"RL"],
["Renegade","Jonathan Willette","USA",208100,1,"HALO"],
["Gustav","Gustav Lykke Bland","Denmark",246843,1,"PUBG"],
["Nate Hill","Nate Hill","USA",255910,0,"FN"],
["Attach","Dillon Price","USA",229727,0,"COD"],
["Frosty","Bradley Bergstrom","USA",228750,1,"HALO"],
["Royal 2","Mathew Fiorante","Canada",228750,1,"HALO"],
["SnakeBite","Paul Duarte","USA",228750,1,"HALO"],
["allu","Aleksi Jalli","Finland",221666,0,"CS2"],
["Astro","Leonardo Luis Buzzachera","Brazil",218323,0,"R6"],
["AYYJAYY","Austin Aebi","USA",218933,0,"RL"],
["Mongraal","Kyle Jackson","UK",197850,0,"FN"],
["jcobbb","Jakub Pietruszewski","Poland",170500,1,"CS2"],
["Twistzz","Russel Van Dulken","Canada",170500,1,"CS2"],
["Fexx","Christopher Stephen Wheddon","UK",164237,1,"PUBG"],
["aizy","Philip Aistrup","Denmark",162661,0,"CS2"],
["Swagg","Kris Lamberson","USA",159133,1,"WZ"],
["Bullet1","José Victor Santos De Souza","Brazil",154069,0,"R6"],
["cameram4n","Gabriel Hespanhol","Brazil",143069,0,"R6"],
["Michael04","Sorawit Rotjanasilapin","Thailand",142283,1,"FO"],
["JubJub","Phatanasak Varanan","Thailand",141459,1,"FO"],
["TDKeane","Teedech Songsaisakul","Thailand",138876,1,"FO"],
["jkaem","Joakim Myrbostad","Norway",127400,0,"CS2"],
["FunkBomb","Trevor Siegler","USA",128873,0,"FN"],
["Clayster","James Eubanks","USA",112543,0,"COD"],
["Jeemzz","Jim Gunnar Eliassen","Norway",111343,1,"PUBG"],
["Curexi","Timi Henry Valtteri Tenhula","Finland",107812,1,"PUBG"],
["Enable","Ian Wyatt","USA",106487,0,"COD"],
["mist","Nick Costello","USA",99301,0,"RL"],
["Priestahh","Preston Greiner","USA",94500,0,"COD"],
["Crowder","Chris Crowder","USA",94500,0,"COD"],
["AdreN","Dauren Qystaubayev","Kazakhstan",89634,0,"CS2"],
["Booya","Ean Chase","USA",72816,1,"WZ"],
["Vintorez","Tharit Pluksang","Thailand",71289,1,"PM"],
["MR5","Thiraphong Murasri","Thailand",70897,0,"PM"],
["Jembty","Jere Kauppinen","Finland",67816,0,"PUBG"],
["Asim","Obaid Asim","Canada",85730,0,"COD"],
["Zer0","Trei Morris","UK",85730,0,"COD"],
["Cellium","McArthur Jovel","USA",85375,0,"COD"],
["Skrapz","Matthew Marshall","UK",85375,0,"COD"],
["mav","Rafael Loureiro Freitas","Brazil",62854,0,"R6"],
["Snip3down","Eric Wrona","USA",59266,1,"APEX"],
["Frexs","Joseph Sanchez","USA",55336,0,"APEX"],
["Phony","Josue Ruiz","USA",55336,0,"APEX"],
["Haxete","Adrian Blom","Sweden",57290,0,"PUBG"],
["yoona","João Gabriel Nerici","Brazil",56994,0,"R6"],
["cameram4n","Gabriel Hespanhol","Brazil",54832,0,"R6"],
["Cented","Evan Barron","Canada",54219,0,"FN"],
["Jaomock","Brendan O'Brien","Canada",47602,0,"FN"],
["Kjaerbye","Markus Kjærbye","Denmark",46400,0,"CS2"],
["fox","Ricardo Pacheco","Portugal",44900,0,"CS2"],
["Tennp0","Jason Wang","USA",42500,0,"FN"],
["NEO","Filip Kubski","Poland",42000,0,"CS2"],
["Slasher","Austin Liddicoat","USA",40280,0,"COD"],
["Sparg0","Edgar Valdez","Mexico",19333,1,"SSBU"],
["Allushin","Braxton Lagarec","Canada",38848,0,"RL"],
["Onzenxs","Kitsada Dontee","Thailand",38570,1,"PM"],
["ion","Ronaldo Osawa","Brazil",37644,0,"R6"],
["MORMAN","Sathit Thanormchit","Thailand",37570,1,"PM"],
["Aches","Patrick Price","USA",35334,0,"COD"],
["D1gg3r1","Daniel Luusua","Finland",35483,0,"PUBG"],
["NICKMERCS","Nick Kolcheff","USA",34751,1,"WZ"],
["MELA","Nuttapat Chitrommetta","Thailand",34479,1,"PM"],
["Bizzle","Timothy Miller","USA",34951,0,"FN"],
["TonyK","Nattawut Muensa","Thailand",32398,0,"PM"],
["Beer11","Pheerapol Phumrat","Thailand",28978,0,"PM"],
["Replays","- -","Canada",28231,1,"FN"],
["babybay","Andrej Francisty","USA",25134,0,"OW"],
["HSnamuringa","João Deam","Brazil",22817,0,"R6"],
["Tass","Tassal Rushan","UK",22158,1,"FIFA"],
["s1mple","Oleksandr Kostyliev","Ukraine",22000,0,"CS2"],
["Gunless","Pierce Hillman","Canada",21815,0,"COD"],
["Bloo","Garrett Underhill","USA",21036,1,"WZ"],
["k1nG","Thiago Bautista Lapp","Argentina",20200,0,"FN"],
["Corey","Corey Nigra","USA",19000,0,"VAL"],
["BulShark","Ratchapol Maneerat","Thailand",18236,0,"PM"],
["Rawkus","Shane Flaherty","USA",18000,0,"VAL"],
["ZachaREEE","Zachary Lombardo","USA",18000,0,"VAL"],
["Yelo","Brandon Yelo","USA",17450,0,"FN"],
["Korpaii","Thaphat Kamphusan","Thailand",18612,0,"PM"],
["Gyro.","Jirair Papazian","USA",16531,0,"RL"],
["Maikelele","Mikail Bill","Sweden",15600,0,"CS2"],
["Lev","Lev Vinken","Netherlands",15500,0,"FIFA"],
["Sinetic","Otso Hirnanen","Finland",14832,1,"APEX"],
["Marved","Jimmy Nguyen","Canada",14200,0,"VAL"],
["Naghz","Ali Naghawi","UK",14169,1,"APEX"],
["04","Jovan Rodriguez","USA",14000,1,"ATL"],
["Abuzah","Jordan François","Belgium",14000,1,"ATL"],
["Drazah","Zachary Jordan","USA",14600,1,"ATL"],
["arctic","Taylor McNeil","UK",12500,0,"APEX"],
["Proofy","Jordan Cannon","USA",12500,0,"COD"],
["JKap","Jordan Kaplan","USA",12500,0,"COD"],
["Rawkus","Shane Flaherty","USA",12381,0,"OW"],
["ShaDowBurn","George Gushcha","Russia",12181,0,"OW"],
["FCTFCTN","Russell Campbell","USA",11801,0,"OW"],
["Spacelyon","Thang Phan","USA",10750,0,"FN"],
["Apathy","Bryan Zhelyazkov","USA",10055,0,"COD"],
["Censor","Douglas Martin","USA",10055,0,"COD"],
["HugeGorilla","Spencer Ealing","UK",10000,0,"FIFA"],
["live","Vinícius dos Santos Monteiro","Brazil",9800,0,"R6"],
["zombs","Jared Gitlin","USA",9241,0,"OW"],
["Forsak3n","Viktors Bernevs","Latvia",9241,0,"OW"],
["LycaN","Apiwat Boonrat","Thailand",8402,0,"PM"],
["TwoEasy","Eric van Hoorn","Netherlands",5141,0,"OW"],
["gohaN","Guilherme Alf","Brazil",7460,0,"R6"],
["Santana","Santana Dante","USA",4834,1,"WZ"],
["Parasite","Christopher Duarte","USA",4315,0,"COD"],
["poised","Kevin Ngo","Canada",5133,0,"VAL"],
["supameN","Phat Le","USA",3133,0,"VAL"],
["sOup77","Paphawin Thanayotpinyo","Thailand",3837,0,"PM"],
["JSmooth","Jordan -","USA",3823,1,"WZ"],
["Tilt","Jonathan De Rosa","USA",4300,0,"FN"],
["diceyzx","Quan Tran","USA",4233,0,"VAL"],
["Karma","Damon Barlow","Canada",4200,0,"COD"],
["flyuh","Xavier Carlson","USA",4233,0,"VAL"],
["Poach","Jake Brumleve","USA",4233,0,"VAL"],
["Thief","Nicholas Smorto","USA",4821,0,"FN"],
["BabyJ","Hunter Schline","USA",3500,0,"VAL"],
["Jarvis","- -","USA",3000,0,"FN"],
["Joemeister","Joe Gramano","Canada",2917,0,"OW"],
["SPREE","Alexandre Vanhomwegen","Belgium",2917,0,"OW"],
["Censor","Douglas Martin","USA",2872,0,"BLK"],
["Carpe","Lee Jae-hyeok","South Korea",2500,0,"OW"],
["Saints","Renato Forza","USA",2445,0,"BLK"],
["Kalei","Kalei Renay","USA",2350,1,"WZ"],
["Martoz","Juan Manuel Ozuduru","Netherlands",1950,0,"FN"],
["Dedo","Ken Dedo","USA",1815,0,"COD"],
["Dedo","Ken Dedo","USA",1872,0,"BLK"],
["FormaL","Matthew Piper","USA",1872,0,"BLK"],
["Bini","Spencer Cherubini","USA",1825,0,"FN"],
["KDS","Eduardo Chiste Fontes Santos","Brazil",1800,0,"R6"],
["Cellium","McArthur Jovel","USA",1495,0,"BLK"],
["Asim","Obaid Asim","Canada",1495,0,"BLK"],
["GRVTY","Thomas Malin","USA",1495,0,"BLK"],
["Phantomz","Timothy Landis","USA",1495,0,"BLK"],
["SlurpeeG","Gregory Sabia","USA",1453,0,"APEX"],
["Echo","Wacharakorn Tiengtis","Thailand",991,0,"PM"],
["Sway","Josue -","USA",900,1,"FN"],
["di^v^","Diane Tran","USA",800,0,"VGC"],
["Emy","Emma Choe","USA",800,0,"VGC"],
["Maddiesunn","Madison Mann","USA",800,0,"VGC"],
["refinnej","Jennifer Le","USA",800,0,"VGC"],
["panini","Vannesa Emory","USA",800,0,"VGC"],
["Classic","Nicholas Di Costanzo","USA",750,0,"RED"],
["Crowder","Chris Crowder","USA",720,0,"RED"],
["JKap","Jordan Kaplan","USA",720,0,"RED"],
["Theory","Dylan McGee","USA",720,0,"RED"],
["Jeffz","Siwagom Pokkasup","Thailand",683,0,"PM"],
["Proofy","Jordan Cannon","USA",659,0,"BLK"],
["Malls","Eddy Maillard","France",659,0,"FRA"],
["Vortex","Brandon Gomes","France",659,0,"FRA"],
["Zeroo","Valentin Langlet","France",659,0,"FRA"],
["ZylewR","Julien Louis","France",659,0,"FRA"],
["Censor","Douglas Martin","USA",543,0,"BLK"],
["Studyy","Jeremy Astacio","USA",543,0,"BLK"],
["Pandxrz","Scott Maynard","USA",500,0,"APEX"],
["Diggy","Kolbe Cordon","USA",500,0,"FN"],
["Apathy","Bryan Zhelyazkov","USA",443,0,"BLK"],
["Lui","Julian Oprandi","USA",434,0,"OW"],
["Faccento","Brice Faccento","USA",306,0,"BLK"],
["VorwenN","Tomas Baldrich Piqué","Spain",559,0,"FN"],
["Slacked","Josiah Berry","USA",312,0,"COD"],
["Faxuty","Moe -","USA",259,1,"FN"],
["Ewok","Soleil Wheeler","USA",100,1,"FN"],
["NICKMERCS","Nick Kolcheff","USA",36,0,"FN"],
["Classic","Nicholas DiCostanzo","USA",0,0,"ATL"],
["Prestinni","Preston Sanderson","USA",0,0,"ATL"],
["Sib","Daunte Gray","USA",0,0,"ATL"],
["GRVTY","Thomas Malin","USA",0,0,"ATL"],
["JurNii","Juan Antonio González Muñoz","Spain",0,0,"ATL"],
["GRVTY","Thomas Malin","USA",0,0,"COD"],
["Cellium","McArthur Jovel","USA",0,0,"COD"],
["Methodz","Anthony Zinni","USA",0,0,"COD"],
["FormaL","Matthew Piper","USA",0,0,"COD"],
["Nameless","Anthony Wheeler","USA",0,0,"COD"],
["Mboze","Marcus Blanks","USA",0,0,"COD"],
["Methodz","Anthony Zinni","USA",0,0,"COD"],
["Parasite","Christopher Duarte","USA",0,0,"BLK"],
["Proofy","Jordan Cannon","USA",0,0,"BLK"],
["Aches","Patrick Price","USA",0,0,"RED"],
["Enable","Ian Wyatt","USA",0,0,"RED"],
["Slasher","Austin Liddicoat","USA",0,0,"RED"],
["Parasite","Christopher Duarte","USA",0,0,"RED"],
["Nio","- -","USA",0,1,"WZ"],
["Jas","Jas Singh","UK",0,0,"FIFA"],
["Mino7x","Amine Boughanmi","France",0,0,"FIFA"],
["HK Jr.","Haktan Kocaman","Germany",0,1,"FG"],
["Joey Fury","Joseph Bennett","USA",0,1,"FG"],
["H1ghSky1","- -","USA",6,1,"FN"],
["72hrs","Thomas Mulligan","USA",0,0,"FN"],
["clampOK","Sabian Hayblum","Australia",0,0,"FN"],
["Mendo","Lucas Håkansson","Sweden",0,0,"OW"],
["Wonderfuls","Kevin Nguyen","USA",0,0,"OW"],
["evokje","Elvinas Padegimas","Lithuania",0,0,"OW"],
["fRoD","Danny Montaner","USA",0,0,"OW"],
["Veineless","Marcel Lehmann","Germany",0,0,"OW"],
["MeToR","Maximilian Lion","Austria",0,0,"PUBG"],
["mummAy","Anthony DiPaolo","USA",0,0,"VAL"],
["TiGG","Tanner Spanu","USA",0,0,"VAL"],
["Rossy","Daniel Abedrabbo","USA",0,0,"VAL"],
["LarryBanks","Christopher Doyi","Canada",0,0,"VAL"],
["ShoT_UP","Andrew Orlowski","USA",0,0,"VAL"],
["jasonr","Jason Ruchelski","Canada",0,0,"VAL"]
];

var grid=document.getElementById('fz-players-grid');
var btn=document.getElementById('fz-players-toggle');
if(!grid||!btn)return;
var showAll=false;

function fmt(n){
  if(n>=1000000)return '$'+((n/1000000).toFixed(1))+'M';
  if(n>=1000)return '$'+((n/1000).toFixed(1))+'K';
  if(n>0)return '$'+n;
  return '$0';
}

function render(){
  var list=showAll?P:P.slice(0,12);
  var h='';
  for(var i=0;i<list.length;i++){
    var p=list[i];
    var team=T[p[5]]||p[5];
    var sc=p[4]?'current':'former';
    var sl=p[4]?'CURRENT':'FORMER';
    h+='<div class="fz-player-card">';
    h+='<div class="fz-player-card__rank">#'+(i+1)+'</div>';
    h+='<h3 class="fz-player-card__tag">'+p[0]+'</h3>';
    h+='<p class="fz-player-card__name">'+p[1]+'</p>';
    h+='<p class="fz-player-card__country">'+p[2]+'</p>';
    h+='<p class="fz-player-card__earnings">'+fmt(p[3])+'</p>';
    h+='<div class="fz-player-card__badges">';
    h+='<span class="fz-player-card__status fz-player-card__status--'+sc+'">'+sl+'</span>';
    h+='<span class="fz-player-card__team">'+team+'</span>';
    h+='</div></div>';
  }
  grid.innerHTML=h;
  btn.textContent=showAll?'SHOW LESS':'VIEW ALL PLAYERS ('+P.length+')';
}

btn.addEventListener('click',function(){
  showAll=!showAll;
  render();
  if(!showAll){grid.scrollIntoView({behavior:'smooth'});}
});

render();
})();
